import { createFileRoute } from '@tanstack/react-router'

import { UnsubscribePage } from '../../components/pages/unsubscribe-page.tsx'

export const Route = createFileRoute('/unsubscribe')({
  component: UnsubscribePage,
})
